<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="newspaper-outline"></ion-icon> Result & Outcome</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Demonstration of results and outcomes of an incubator deals in
              terms of both tangible measures and intangible measures as
              follows:
            </li>
            <li>
              How many Startup ventures are being incubated; How many have
              graduated; How many have secured next level funding; Tangible
              performance metrics of the ventures in terms of financial metrics;
              Intangible metrics like local indirect employment generation,
              innovation and social impact.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>Final Results and Outcome; Impact Created; Numbers Achieved</li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Number of Graduated Startups annually in the last three
                    years of operations
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.numberOfGraduatedStatus)"
                    [style.background]="
                      pickColor(getValue.numberOfGraduatedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.numberOfGraduatedStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Number of Graduated Startups annually in the last three
                      years of operations
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.numberOfGraduatedStatus != 2 &&
                        getValue.numberOfGraduatedStatus != 4 &&
                        getValue.numberOfGraduatedStatus != 5 &&
                        getValue.numberOfGraduatedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="numberOfGraduatedIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsone(
                              $event.value,
                              '.upload0',
                              0,
                              '.set-succ0'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.numberOfGraduatedIncCentre.touched &&
                              setting.numberOfGraduatedIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.numberOfGraduatedIncCentre.touched &&
                            setting.numberOfGraduatedIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.numberOfGraduatedIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsonechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of Graduated startups
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter No. of Graduated startups "
                                    formControlName="numberOfGraduatedNoOfStartup"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'numberOfGraduatedStatus',
                                        7
                                      )
                                    "
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.numberOfGraduatedNoOfStartup
                                          .touched &&
                                        setting.numberOfGraduatedNoOfStartup
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.numberOfGraduatedNoOfStartup
                                        .touched &&
                                      setting.numberOfGraduatedNoOfStartup
                                        .errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.numberOfGraduatedNoOfStartup
                                          .errors.required
                                      "
                                      >No. of Graduated startups is
                                      required</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload0">
                                  <input
                                    type="file"
                                    formControlName="numberOfGraduatedImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload0',
                                        0,
                                        '.set-succ0'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.numberOfGraduatedImagefile
                                          .touched &&
                                        setting.numberOfGraduatedImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.numberOfGraduatedImagefile
                                      .touched &&
                                    setting.numberOfGraduatedImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.numberOfGraduatedImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload0"
                                  (click)="
                                    removeFile('.upload0', 0, '.set-succ0')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.numberOfGraduatedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.numberOfGraduatedReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.numberOfGraduatedStatus == 2 ||
                        getValue.numberOfGraduatedStatus == 4 ||
                        getValue.numberOfGraduatedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.numberOfGraduatedIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.numberOfGraduatedNoOfStartup }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.numberOfGraduatedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.numberOfGraduatedStatus == 3 ||
                            getValue.numberOfGraduatedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.numberOfGraduatedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Capacity Utilization such as Office Space, Machinery
                    established and other infrastructure
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.capacityUtilizationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.capacityUtilizationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.capacityUtilizationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Capacity Utilization such as Office Space, Machinery
                      established and other infrastructure
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.capacityUtilizationStatus != 2 &&
                        getValue.capacityUtilizationStatus != 4 &&
                        getValue.capacityUtilizationStatus != 5 &&
                        getValue.capacityUtilizationStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="capacityUtilizationIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.capacityUtilizationIncCentre.touched &&
                              setting.capacityUtilizationIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.capacityUtilizationIncCentre.touched &&
                            setting.capacityUtilizationIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.capacityUtilizationIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionstwochecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="capacityUtilizationUrlIcWebsite"
                                (change)="
                                  setStatus(
                                    $event,
                                    'capacityUtilizationStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.capacityUtilizationUrlIcWebsite
                                      .touched &&
                                    setting.capacityUtilizationUrlIcWebsite
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.capacityUtilizationUrlIcWebsite
                                    .touched &&
                                  setting.capacityUtilizationUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.capacityUtilizationUrlIcWebsite
                                      .errors.required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.capacityUtilizationUrlIcWebsite
                                      .errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <mat-label
                              >Percentage of Capacity Utilization
                              <span class="text-danger">*</span></mat-label
                            >
                            <br />
                            <div class="mt-3">
                              <mat-radio-group
                                formControlName="capacityUtilizationPercentage"
                                class="example-margin"
                                aria-label="Select an option"
                                (change)="
                                  setStatus(
                                    $event,
                                    'capacityUtilizationStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.capacityUtilizationPercentage
                                      .touched &&
                                    setting.capacityUtilizationPercentage.errors
                                }"
                              >
                                <mat-radio-button value="25">
                                  0 - 24%</mat-radio-button
                                >
                                <mat-radio-button value="50">
                                  25 - 50%</mat-radio-button
                                >
                                <mat-radio-button value="75">
                                  51 - 75%</mat-radio-button
                                >
                                <mat-radio-button value="100">
                                  76 - 100%</mat-radio-button
                                >
                              </mat-radio-group>
                              <br />
                              <mat-error
                                *ngIf="
                                  setting.capacityUtilizationPercentage
                                    .touched &&
                                  setting.capacityUtilizationPercentage.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.capacityUtilizationPercentage.errors
                                      .required
                                  "
                                  >Percentage of Capacity Utilization is
                                  required</span
                                >
                              </mat-error>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="capacityUtilizationImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.capacityUtilizationImagefile
                                          .touched &&
                                        setting.capacityUtilizationImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.capacityUtilizationImagefile
                                      .touched &&
                                    setting.capacityUtilizationImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.capacityUtilizationImagefile
                                        .errors.required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.capacityUtilizationStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.capacityUtilizationReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.capacityUtilizationStatus == 2 ||
                        getValue.capacityUtilizationStatus == 4 ||
                        getValue.capacityUtilizationStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.capacityUtilizationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.capacityUtilizationUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.capacityUtilizationUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Percentage of Capacity Utilization :
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 25
                              "
                              ><b>0 - 24%</b>
                            </span>
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 50
                              "
                              ><b>25 - 50%</b>
                            </span>
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 75
                              "
                              ><b>51 - 75%</b>
                            </span>
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 100
                              "
                              ><b>76 - 100%</b>
                            </span>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.capacityUtilizationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.capacityUtilizationStatus == 3 ||
                            getValue.capacityUtilizationStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.capacityUtilizationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Impact achieved against targeted impact through Incubated
                    startups / incubator
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.impactAchievedStatus)"
                    [style.background]="
                      pickColor(getValue.impactAchievedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.impactAchievedStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Impact achieved against targeted impact through Incubated
                      startups / incubator
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.impactAchievedStatus != 2 &&
                        getValue.impactAchievedStatus != 4 &&
                        getValue.impactAchievedStatus != 5 &&
                        getValue.impactAchievedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="impactAchievedPresent"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions10(
                              $event.value,
                              '.upload9',
                              9,
                              '.set-succ9'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.impactAchievedPresent.touched &&
                              setting.impactAchievedPresent.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.impactAchievedPresent.touched &&
                            setting.impactAchievedPresent.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.impactAchievedPresent.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options10checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload9">
                                  <input
                                    type="file"
                                    formControlName="impactAchievedImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload9',
                                        9,
                                        '.set-succ9'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.impactAchievedImagefile
                                          .touched &&
                                        setting.impactAchievedImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.impactAchievedImagefile.touched &&
                                    setting.impactAchievedImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.impactAchievedImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload9"
                                  (click)="
                                    removeFile('.upload9', 9, '.set-succ9')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.impactAchievedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.impactAchievedReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.impactAchievedStatus == 2 ||
                        getValue.impactAchievedStatus == 4 ||
                        getValue.impactAchievedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.impactAchievedPresent }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.impactAchievedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.impactAchievedStatus == 3 ||
                            getValue.impactAchievedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.impactAchievedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Technology Commercialized / Transferred for the technology
                    developed through Host Institute in the last one year
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.technologyCommercializedStatus)
                    "
                    [style.background]="
                      pickColor(getValue.technologyCommercializedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.technologyCommercializedStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Technology Commercialized / Transferred for the technology
                      developed through Host Institute in the last one year
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.technologyCommercializedStatus != 2 &&
                        getValue.technologyCommercializedStatus != 4 &&
                        getValue.technologyCommercializedStatus != 5 &&
                        getValue.technologyCommercializedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="technologyCommercializedPresent"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions11(
                              $event.value,
                              '.upload10',
                              10,
                              '.set-succ10'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.technologyCommercializedPresent.touched &&
                              setting.technologyCommercializedPresent.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.technologyCommercializedPresent.touched &&
                            setting.technologyCommercializedPresent.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.technologyCommercializedPresent.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options11checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of technology commercialized /
                                    transferred
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter No. of technology commercialized / transferred  "
                                    formControlName="technologyCommercializedNoOfTech"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'technologyCommercializedStatus',
                                        7
                                      )
                                    "
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.technologyCommercializedNoOfTech
                                          .touched &&
                                        setting.technologyCommercializedNoOfTech
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.technologyCommercializedNoOfTech
                                        .touched &&
                                      setting.technologyCommercializedNoOfTech
                                        .errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.technologyCommercializedNoOfTech
                                          .errors.required
                                      "
                                      >No. of technology commercialized /
                                      transferred is required</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload10">
                                  <input
                                    type="file"
                                    formControlName="technologyCommercializedImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload10',
                                        10,
                                        '.set-succ10'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .technologyCommercializedImagefile
                                          .touched &&
                                        setting
                                          .technologyCommercializedImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.technologyCommercializedImagefile
                                      .touched &&
                                    setting.technologyCommercializedImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.technologyCommercializedImagefile
                                        .errors.required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload10"
                                  (click)="
                                    removeFile('.upload10', 10, '.set-succ10')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.technologyCommercializedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.technologyCommercializedReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.technologyCommercializedStatus == 2 ||
                        getValue.technologyCommercializedStatus == 4 ||
                        getValue.technologyCommercializedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.technologyCommercializedPresent
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{
                              getValue.technologyCommercializedNoOfTech
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.technologyCommercializedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.technologyCommercializedStatus == 3 ||
                            getValue.technologyCommercializedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.impactAchievedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
          <div class="text-center mt-3" *ngIf="getValue.enableSaveAll == 1">
            <button mat-raised-button color="primary" (click)="SaveAllApi()">
              Submit for Evaluation
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
